module.exports = __webpack_public_path__ + "static/media/14.877d88b3.jpeg";